// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../../reason/next/Next.bs.js");
let React = require("react");
let Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ConversationsPageRelayCommon = require("./ConversationsPageRelayCommon.bs.js");
let ConversationParticipantsDisplay = require("./ConversationParticipantsDisplay.bs.js");
let ConversationPageNotAnonymousWarning = require("./ConversationPageNotAnonymousWarning.bs.js");
let ConversationPageConversationMessages = require("./ConversationPageConversationMessages.bs.js");
let ConversationPageSelectedConversationContext = require("./ConversationPageSelectedConversationContext.bs.js");
let ConversationPageSelectedConversationMatches = require("./ConversationPageSelectedConversationMatches.bs.js");
let ConversationPageNewConversationQuery_graphql = require("../../../__generated__/ConversationPageNewConversationQuery_graphql.bs.js");
let Conversation__ConversationsSection__StartFirstConversation = require("../conversationsSection/Conversation__ConversationsSection__StartFirstConversation.bs.js");
let ConversationPageNewConversationByType_conversationContext_graphql = require("../../../__generated__/ConversationPageNewConversationByType_conversationContext_graphql.bs.js");
let ConversationPageNewConversationDisplayer_conversationContext_graphql = require("../../../__generated__/ConversationPageNewConversationDisplayer_conversationContext_graphql.bs.js");

let convertVariables = ConversationPageNewConversationQuery_graphql.Internal.convertVariables;

let convertResponse = ConversationPageNewConversationQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = ConversationPageNewConversationQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, ConversationPageNewConversationQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, ConversationPageNewConversationQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(ConversationPageNewConversationQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(ConversationPageNewConversationQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(ConversationPageNewConversationQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(ConversationPageNewConversationQuery_graphql.node, convertVariables);

let Query_conversationContextTypeV5_decode = ConversationPageNewConversationQuery_graphql.Utils.conversationContextTypeV5_decode;

let Query_conversationContextTypeV5_fromString = ConversationPageNewConversationQuery_graphql.Utils.conversationContextTypeV5_fromString;

let Query_membershipStatusV5_decode = ConversationPageNewConversationQuery_graphql.Utils.membershipStatusV5_decode;

let Query_membershipStatusV5_fromString = ConversationPageNewConversationQuery_graphql.Utils.membershipStatusV5_fromString;

let Query_messageBroadcasStatus_decode = ConversationPageNewConversationQuery_graphql.Utils.messageBroadcasStatus_decode;

let Query_messageBroadcasStatus_fromString = ConversationPageNewConversationQuery_graphql.Utils.messageBroadcasStatus_fromString;

let Query = {
  conversationContextTypeV5_decode: Query_conversationContextTypeV5_decode,
  conversationContextTypeV5_fromString: Query_conversationContextTypeV5_fromString,
  membershipStatusV5_decode: Query_membershipStatusV5_decode,
  membershipStatusV5_fromString: Query_membershipStatusV5_fromString,
  messageBroadcasStatus_decode: Query_messageBroadcasStatus_decode,
  messageBroadcasStatus_fromString: Query_messageBroadcasStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

let convertFragment = ConversationPageNewConversationDisplayer_conversationContext_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageNewConversationDisplayer_conversationContext_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageNewConversationDisplayer_conversationContext_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageNewConversationDisplayer_conversationContext_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageNewConversationDisplayer_conversationContext_graphql.node, convertFragment, fRef);
}

let ConversationContextFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = ConversationPageNewConversationByType_conversationContext_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageNewConversationByType_conversationContext_graphql.node, convertFragment$1, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageNewConversationByType_conversationContext_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageNewConversationByType_conversationContext_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageNewConversationByType_conversationContext_graphql.node, convertFragment$1, fRef);
}

let ByTypeFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ConversationPageNewConversation$Displayer(props) {
  let contextForConversation = props.contextForConversation;
  let conversationContext = RescriptRelay_Fragment.useFragment(ConversationPageNewConversationDisplayer_conversationContext_graphql.node, convertFragment, props.conversationContext);
  let byType = RescriptRelay_Fragment.useFragment(ConversationPageNewConversationByType_conversationContext_graphql.node, convertFragment$1, conversationContext.fragmentRefs);
  let router = Next.useRouter();
  let match = React.useState(() => false);
  let setShowLoadingIndicator = match[1];
  let tmp;
  switch (byType.__typename) {
    case "ForSalePropertyV5" :
      let match$1 = byType.agentV2;
      if (match$1 !== undefined) {
        switch (match$1.__typename) {
          case "AnonymousForSalePropertyAgent" :
            tmp = ["AnonymousConversationParticipant"];
            break;
          case "VisibleForSalePropertyAgent" :
            let match$2 = match$1.agent;
            tmp = match$2 !== undefined ? [{
                  TAG: "Agent",
                  id: match$2.id,
                  fragmentRefs: match$2.fragmentRefs,
                  displayName: match$2.displayName
                }] : [];
            break;
          case "__unselected" :
            tmp = [];
            break;
        }
      } else {
        tmp = [];
      }
      break;
    case "__unselected" :
      tmp = [];
      break;
    default:
      let match$3 = byType.agent;
      tmp = match$3 !== undefined ? [{
            TAG: "Agent",
            id: match$3.id,
            fragmentRefs: match$3.fragmentRefs,
            displayName: match$3.displayName
          }] : [];
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ConversationParticipantsDisplay.ByParticipants.make, {
          participants: tmp
        })
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ConversationPageSelectedConversationContext.make, {
          conversationContext: contextForConversation
        })
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ConversationPageSelectedConversationMatches.make, {
          conversationContext: contextForConversation
        })
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ConversationPageConversationMessages.MessagesContainer.make, {
                children: match[0] ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(Loader.make, {
                      size: "medium"
                    }),
                    className: "p-4"
                  }) : null
              })
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ConversationPageNotAnonymousWarning.make, {
                conversationContext: contextForConversation,
                isNewConversation: true
              }),
              className: "mt-4 mb-8 p-4"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Conversation__ConversationsSection__StartFirstConversation.make, {
                context: conversationContext.fragmentRefs,
                onStartedInitiatingConversation: () => setShowLoadingIndicator(param => true),
                onConversationInitiated: newConversationId => Next.Router.replace("/conversations/" + newConversationId, undefined, undefined, router)
              })
            })
          ]
        })
      })
    ],
    className: "p-4 flex flex-col space-y-4"
  });
}

let Displayer = {
  ConversationContextFragment: ConversationContextFragment,
  ByTypeFragment: ByTypeFragment,
  StartFirstConversation: undefined,
  make: ConversationPageNewConversation$Displayer
};

function ConversationPageNewConversation(props) {
  let data = use({
    entityType: props.entityType,
    id: props.entityId
  }, undefined, undefined, undefined);
  let conversationContext = data.newConversationContextV5;
  let tmp;
  if (conversationContext !== undefined) {
    let context = conversationContext.context;
    let tmp$1;
    let exit = 0;
    let displayName;
    let context$1 = conversationContext.context;
    if (context$1 !== undefined) {
      let match = context$1.agent;
      let exit$1 = 0;
      let exit$2 = 0;
      if (match !== undefined) {
        let tmp$2 = match.membershipStatus;
        if (tmp$2 === "TERMINATED") {
          displayName = match.displayName;
          exit = 1;
        } else {
          exit$2 = 3;
        }
      } else {
        exit$2 = 3;
      }
      if (exit$2 === 3) {
        let match$1 = context$1.agentV2;
        let exit$3 = 0;
        if (match$1 !== undefined && match$1.__typename === "VisibleForSalePropertyAgent") {
          let match$2 = match$1.agent;
          if (match$2 !== undefined) {
            let tmp$3 = match$2.membershipStatus;
            if (tmp$3 === "TERMINATED") {
              displayName = match$2.displayName;
              exit = 1;
            } else {
              exit$3 = 4;
            }
          } else {
            exit$3 = 4;
          }
        } else {
          exit$3 = 4;
        }
        if (exit$3 === 4) {
          let match$3 = context$1.messageBroadcastStatus;
          if (match$3 === "DELETED") {
            tmp$1 = JsxRuntime.jsx("div", {
              children: "The broadcast message has been deleted",
              className: "p-2"
            });
          } else {
            exit$1 = 2;
          }
        }
      }
      if (exit$1 === 2) {
        tmp$1 = JsxRuntime.jsx(ConversationPageNewConversation$Displayer, {
          conversationContext: context$1.fragmentRefs,
          contextForConversation: conversationContext.fragmentRefs
        });
      }
    } else {
      tmp$1 = null;
    }
    if (exit === 1) {
      tmp$1 = JsxRuntime.jsx("div", {
        children: `Unable to message as ` + displayName + ` no longer has an active subscription on TAN`,
        className: "p-2"
      });
    }
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        context !== undefined ? JsxRuntime.jsx(ConversationsPageRelayCommon.RecordPageView.ConversationViewByConversationContext.make, {
            conversationContext: Primitive_option.some(context.fragmentRefs),
            activeConversationId: props.originalConversationId
          }) : null,
        tmp$1
      ]
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: tmp
  });
}

let make = ConversationPageNewConversation;

exports.Query = Query;
exports.Displayer = Displayer;
exports.make = make;
/* use Not a pure module */
